import {
  RECEIVE_LOAN_OFFER,
  PAYMENT_SCHEDULE_FETCH_SUCCESS,
  PAYMENT_SCHEDULE_SELECTED,
} from '../actionTypes';

let initialState = {
  loan_plan_preview_schedules: [
    {
      payment_schedules: [{}]
    }
  ]
}

export default function loanOffer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_LOAN_OFFER:
    case PAYMENT_SCHEDULE_FETCH_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case PAYMENT_SCHEDULE_SELECTED:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/reducers/loanOffer.js